import React from 'react';

class SelectedImagePreview extends React.Component {
	render() {
		const file = this.props.file || null;
		const className = this.props.className || "";
		const src = this.props.src;
		const id = this.props.id;
		
		// console.log(id, "onImgLoad", onImgLoad);

		if(file !== null) {
			var reader = new FileReader();
	        reader.onload = function (e) {
	        	var img = document.getElementById(id);
				const onImgLoad = this.props.onImgLoad;
				
	        	if(img) {
					var imgClassName = img.getAttribute("class").replace("invisible", "");
					img.setAttribute('src', e.target.result);
					img.setAttribute('class', imgClassName);

					img.onload = () => {
						if(onImgLoad && typeof onImgLoad === 'function')
							this.props.onImgLoad(img);
					};
				}
	        }.bind(this);

	        reader.readAsDataURL(file);
			
	        return <img id={id} style={this.props.style} alt={id} className={'miniImg invisible '+className} />;
		} else if (src != null) {
			return <img id={id} style={this.props.style} src={src} alt={id} className={'miniImg '+className} />;
		} else {
			return <div id={id} style={this.props.style} className={"miniImageLoader "+className}></div>;
		}
	}
}


export default SelectedImagePreview;


// WEBPACK FOOTER //
// ./src/views/product/SelectedImagePreview.js